export enum CAMPAIGN_GROUP_TYPE {
  HAVE_NOT_VISITED_IN = 'HAVE_NOT_VISITED_IN',
  VISITED_WITHIN = 'VISITED_WITHIN',
  REVIEW_GROUP = 'REVIEW_GROUP',
  NUMBER_OF_VISIT = 'NUMBER_OF_VISIT',
  AVG_VISIT = 'AVG_VISIT',
  REWARD_GROUP = 'REWARD_GROUP',
  BIRTHDAY_MONTH = 'BIRTHDAY_MONTH',
}

export enum TIME_PERIOD_DAYS {
  DAYS_14 = 14,
  DAYS_21 = 21,
  DAYS_30 = 30,
  DAYS_60 = 60,
  DAYS_90 = 90,
  DAYS_180 = 180,
  DAYS_365 = 365,
}

export enum REVIEW_STARS {
  STAR_1_2_3 = 'STAR_1_2_3', // 1-3 stars
  STAR_4_5 = 'STAR_4_5', // 4-5 stars
}

export enum VISIT_COUNT {
  VISIT_1 = 'VISIT_1', // 1 visit
  VISIT_2_3_4 = 'VISIT_2_3_4', // 2-4 visits
  VISIT_OVER_5 = 'VISIT_OVER_5', // 5+ visits
}

export enum AVG_SPEND {
  AVG_1_39 = 'AVG_1_39', // $1.00 - $39.00
  AVG_40_59 = 'AVG_40_59', // $40.00 - $59.00
  AVG_60_99 = 'AVG_60_99', // $60.00 - $99.00
  OVER_100 = 'OVER_100', // $100.00+
}

export enum REWARD_STATUS {
  NORMAL = 'NORMAL', // No VIP Membership
  FREE_REWARD = 'FREE_REWARD', // Free Reward
  PAID_VIP = 'PAID_VIP', // Paid VIP
}

export enum BIRTH_MONTH {
  JAN = 'JAN',
  FEB = 'FEB',
  MAR = 'MAR',
  APR = 'APR',
  MAY = 'MAY',
  JUNE = 'JUNE',
  JULY = 'JULY',
  AUG = 'AUG',
  SEP = 'SEP',
  OCT = 'OCT',
  NOV = 'NOV',
  DEC = 'DEC',
}

export const customerFilterTag = [
  {
    value: `${CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN}_${TIME_PERIOD_DAYS.DAYS_14}`,
    label: 'Have Not Visited: 14 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN}_${TIME_PERIOD_DAYS.DAYS_21}`,
    label: 'Have Not Visited: 21 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN}_${TIME_PERIOD_DAYS.DAYS_30}`,
    label: 'Have Not Visited: 30 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN}_${TIME_PERIOD_DAYS.DAYS_60}`,
    label: 'Have Not Visited: 60 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN}_${TIME_PERIOD_DAYS.DAYS_90}`,
    label: 'Have Not Visited: 90 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN}_${TIME_PERIOD_DAYS.DAYS_180}`,
    label: 'Have Not Visited: 180 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN}_${TIME_PERIOD_DAYS.DAYS_365}`,
    label: 'Have Not Visited: 365 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.VISITED_WITHIN}_${TIME_PERIOD_DAYS.DAYS_14}`,
    label: 'Visited Within: 14 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.VISITED_WITHIN}_${TIME_PERIOD_DAYS.DAYS_21}`,
    label: 'Visited Within: 21 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.VISITED_WITHIN}_${TIME_PERIOD_DAYS.DAYS_30}`,
    label: 'Visited Within: 30 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.VISITED_WITHIN}_${TIME_PERIOD_DAYS.DAYS_60}`,
    label: 'Visited Within: 60 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.VISITED_WITHIN}_${TIME_PERIOD_DAYS.DAYS_90}`,
    label: 'Visited Within: 90 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.VISITED_WITHIN}_${TIME_PERIOD_DAYS.DAYS_180}`,
    label: 'Visited Within: 180 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.VISITED_WITHIN}_${TIME_PERIOD_DAYS.DAYS_365}`,
    label: 'Visited Within: 365 days',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.REVIEW_GROUP}_${REVIEW_STARS.STAR_1_2_3}`,
    label: 'Review Group: 1-3 stars',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.REVIEW_GROUP}_${REVIEW_STARS.STAR_4_5}`,
    label: 'Review Group: 4-5 stars',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.NUMBER_OF_VISIT}_${VISIT_COUNT.VISIT_1}`,
    label: 'Number of Visit: 1 visit',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.NUMBER_OF_VISIT}_${VISIT_COUNT.VISIT_2_3_4}`,
    label: 'Number of Visit: 2-4 visits',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.NUMBER_OF_VISIT}_${VISIT_COUNT.VISIT_OVER_5}`,
    label: 'Number of Visit: 5+ visits',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.AVG_VISIT}_${AVG_SPEND.AVG_1_39}`,
    label: 'Avg $/Visit: $1.00 - $39.00',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.AVG_VISIT}_${AVG_SPEND.AVG_40_59}`,
    label: 'Avg $/Visit: $40.00 - $59.00',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.AVG_VISIT}_${AVG_SPEND.AVG_60_99}`,
    label: 'Avg $/Visit: $60.00 - $99.00',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.AVG_VISIT}_${AVG_SPEND.OVER_100}`,
    label: 'Avg $/Visit: $100.00+',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.REWARD_GROUP}_${REWARD_STATUS.NORMAL}`,
    label: 'Reward Group: No VIP Membership',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.REWARD_GROUP}_${REWARD_STATUS.FREE_REWARD}`,
    label: 'Reward Group: Free Reward',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.REWARD_GROUP}_${REWARD_STATUS.PAID_VIP}`,
    label: 'Reward Group: Paid VIP',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.JAN}`,
    label: 'Birthday Month: January',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.FEB}`,
    label: 'Birthday Month: February',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.MAR}`,
    label: 'Birthday Month: March',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.APR}`,
    label: 'Birthday Month: April',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.MAY}`,
    label: 'Birthday Month: May',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.JUNE}`,
    label: 'Birthday Month: June',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.JULY}`,
    label: 'Birthday Month: July',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.AUG}`,
    label: 'Birthday Month: August',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.SEP}`,
    label: 'Birthday Month: September',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.OCT}`,
    label: 'Birthday Month: October',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.NOV}`,
    label: 'Birthday Month: November',
  },
  {
    value: `${CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH}_${BIRTH_MONTH.DEC}`,
    label: 'Birthday Month: December',
  },
];

export const timePeriodOptions = [
  { value: TIME_PERIOD_DAYS.DAYS_14, label: '14 days' },
  { value: TIME_PERIOD_DAYS.DAYS_21, label: '21 days' },
  { value: TIME_PERIOD_DAYS.DAYS_30, label: '30 days' },
  { value: TIME_PERIOD_DAYS.DAYS_60, label: '60 days' },
  { value: TIME_PERIOD_DAYS.DAYS_90, label: '90 days' },
  { value: TIME_PERIOD_DAYS.DAYS_180, label: '180 days' },
  { value: TIME_PERIOD_DAYS.DAYS_365, label: '365 days' },
];

export const reviewStarsOptions = [
  { value: REVIEW_STARS.STAR_1_2_3, label: '1-3 stars' },
  { value: REVIEW_STARS.STAR_4_5, label: '4-5 stars' },
];

export const visitCountOptions = [
  { value: VISIT_COUNT.VISIT_1, label: '1 visit' },
  { value: VISIT_COUNT.VISIT_2_3_4, label: '2-4 visits' },
  { value: VISIT_COUNT.VISIT_OVER_5, label: '5+ visits' },
];

export const avgSpendOptions = [
  { value: AVG_SPEND.AVG_1_39, label: '$1.00 - $39.00' },
  { value: AVG_SPEND.AVG_40_59, label: '$40.00 - $59.00' },
  { value: AVG_SPEND.AVG_60_99, label: '$60.00 - $99.00' },
  { value: AVG_SPEND.OVER_100, label: '$100.00+' },
];

export const rewardStatusOptions = [
  { value: REWARD_STATUS.NORMAL, label: 'No VIP Membership' },
  { value: REWARD_STATUS.FREE_REWARD, label: 'Free Reward' },
  { value: REWARD_STATUS.PAID_VIP, label: 'Paid VIP' },
];

export const birthdayMonthOptions = [
  { value: BIRTH_MONTH.JAN, label: 'January' },
  { value: BIRTH_MONTH.FEB, label: 'February' },
  { value: BIRTH_MONTH.MAR, label: 'March' },
  { value: BIRTH_MONTH.APR, label: 'April' },
  { value: BIRTH_MONTH.MAY, label: 'May' },
  { value: BIRTH_MONTH.JUNE, label: 'June' },
  { value: BIRTH_MONTH.JULY, label: 'July' },
  { value: BIRTH_MONTH.AUG, label: 'August' },
  { value: BIRTH_MONTH.SEP, label: 'September' },
  { value: BIRTH_MONTH.OCT, label: 'October' },
  { value: BIRTH_MONTH.NOV, label: 'November' },
  { value: BIRTH_MONTH.DEC, label: 'December' },
];
export const groupCampaignOptions = [
  { value: CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN, label: 'Have Not Visited' },
  { value: CAMPAIGN_GROUP_TYPE.VISITED_WITHIN, label: 'Visited Within' },
  { value: CAMPAIGN_GROUP_TYPE.REVIEW_GROUP, label: 'Review Group' },
  { value: CAMPAIGN_GROUP_TYPE.NUMBER_OF_VISIT, label: 'Number of Visit' },
  { value: CAMPAIGN_GROUP_TYPE.AVG_VISIT, label: 'Avg $/Visit' },
  { value: CAMPAIGN_GROUP_TYPE.REWARD_GROUP, label: 'Reward Group' },
  { value: CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH, label: 'Birthday Month' },
];
